<div class="basic">
  <header>
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <a class="logo mr-auto">
          <img alt="" src="./assets/images/eiac_logo.png"/>
        </a>
        <button
          [routerLink]="'login'"
          class="mr-4 login-btn d-none"
          mat-stroked-button
        >
          Login
        </button>
        <!-- <a (click)="changeLanguage()">
          <img alt="" src="./assets/images/icons/language-icon.svg"/>
          <span>
            {{ 'general.language' | translate }}
          </span></a
        > -->
      </div>
    </div>
  </header>
  <router-outlet></router-outlet>
  <footer class="footer-bottom">
    <div class="container">
      <div>
        <div class="copyRight">
          Copyright {{year}}  EIAC  , All Rights Reserved

        </div>
      </div>
    </div>
  </footer>
</div>
